import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, tap } from 'rxjs';
import { ClientConfig, OcrKeysAndroidAndIos } from '../types/config/config.types';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.url.api}/config`;

  ocrKeys: OcrKeysAndroidAndIos;

  getClientConfig(): Observable<ClientConfig> {
    return this.http.get<ClientConfig>(`${this.url}/client/user/me`).pipe(
      tap((config: ClientConfig) => {
        this.ocrKeys = config.document.ocr;
      })
    );
  }
}
